import { MotionGrid } from "./components/MotionGrid";
import { ReactComponent as GlrSvg } from "./components/glr.svg";
import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { ClassSelector } from "./components/ClassSelector/ClassSelector";
import { PresentationModal } from "./components/PresentationModal/PresentationModal";
import { useBaseContext } from "./context/BaseContext";
import { Clock } from "./components/Clock";
import ToolBox from "./components/ToolBox";

export default function App() {
  const { selectedClass } = useBaseContext();

  return (
    <Box>
      <PresentationModal />

      <Stack
        width="100%"
        direction="row"
        sx={{
          position: "fixed",
          justifyContent: "space-between",
          zIndex: 1,
          "& > *": {
            width: "50%",
            textAlign: "center",
          },
          "&:before": {
            background: "linear-gradient(var(--body) 22%, transparent 100%)",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: -250,
            content: '""',
            zIndex: -1,
          },
        }}
      >
        <Box m={2}>
          <Clock />
        </Box>

        <GlrSvg style={{ scale: 1.3, transformOrigin: "top" }} />

        <Box m={2}>
          <Stack direction="column" gap={2} m={2} alignItems="flex-end">
            <Typography
              variant="h1"
              fontWeight="bold"
              color="white"
              sx={{
                borderRadius: "15px",
                padding: "10px 20px",
                background: "rgb(0 0 0 / 10%)",
                backdropFilter: "blur(5px)",
              }}
            >
              <Box contentEditable>WLED</Box>
            </Typography>
            <ClassSelector />
          </Stack>
        </Box>
      </Stack>

      <MotionGrid selectedClass={selectedClass} />
      <ToolBox />
    </Box>
  );
}
